<template>
  <InspectionReport :resource="report" :categories="categories" />
</template>

<script>
  import InspectionReport from '@/ui/components/inspectionReport/InspectionReport';
  import { now } from '@/_legacy/util/UnixTimestamps';

  export default {
    components: { InspectionReport },

    props: {
      resource: {
        type: Object,
        required: true,
      },
      template: {
        type: Object,
        required: true,
      },
    },

    computed: {
      report() {
        const report = JSON.parse(JSON.stringify(this.resource));

        report.template = JSON.parse(JSON.stringify(this.template));
        report.template.score_range_labels = [
          {
            min: 0,
            max: 70,
            label: this.$t('Not acceptable'),
            color: '#FF6E44',
          },
        ];
        // Below are random percentages to be displayed in the preview of the report depending on whether
        // average_weighted_score_calculation flag is set on the template
        report.percentage = report.template.average_weighted_score_calculation ? 16.17 : 60;
        report.form.items[1].percentage = report.template.average_weighted_score_calculation ? 11.5 : 50;
        report.form.items[2].percentage = report.template.average_weighted_score_calculation ? 4.67 : 66.66;
        report.entity_item = 1;
        report.entity_items = { 1: 'Friedrichstraße Berlin' };
        report.conducted_by = 'Karsten Gado';
        report.conducted_at = now();
        return report;
      },
      categories() {
        return [
          { value: 1, label: 'A' },
          { value: 2, label: 'B' },
          { value: 3, label: 'C' },
        ];
      },
    },
  };
</script>
